import React, { useState, useEffect } from "react";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { nftTempImage } from "../../constants";
import { tokens } from "../../theme";
import { useTypedSelector } from "../../hooks/useTypedSelector";
import { NoData } from "../../components/NoData";
import { ethLogo } from "../../assets";

const colorArr = [
  "44ACFF",
  "020202",
  "FF6DB3",
  "FDD25D",
  "50AF95",
  "44ACFF",
  "020202",
  "FF6DB3",
  "FDD25D",
  "50AF95",
];

const addingColor = (array) => {
  return array.map((arr, index) => {
    return {
      ...arr,
      color: colorArr[index],
    };
  });
};

const tokensList = [
  {
    id: 1,
    name: "DAO",
    logo: ethLogo,
    price: "$12,000",
    amount: "2,500",
    value: "$250.23",
    accountAllocation: "47%",
  },
  {
    id: 2,
    name: "DAO",
    logo: ethLogo,
    price: "$12,000",
    amount: "2,500",
    value: "$250.23",
    accountAllocation: "47%",
  },
  {
    id: 3,
    name: "DAO",
    logo: ethLogo,
    price: "$12,000",
    amount: "2,500",
    value: "$250.23",
    accountAllocation: "47%",
  },
  {
    id: 4,
    name: "DAO",
    logo: ethLogo,
    price: "$12,000",
    amount: "2,500",
    value: "$250.23",
    accountAllocation: "47%",
  },
  {
    id: 5,
    name: "DAO",
    logo: ethLogo,
    price: "$12,000",
    amount: "2,500",
    value: "$250.23",
    accountAllocation: "47%",
  },
];

export const TokensTable = ({ tokensPage = false }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const { holdings } = useTypedSelector((state) => state.apiReducer);

  console.log("holdings in table", holdings);

  const [collectibles, setCollectibles] = useState(addingColor(holdings));

  useEffect(() => {
    setCollectibles(addingColor(holdings));
  }, [holdings]);

  console.log("tokenslist", collectibles);
  const columns = [
    {
      field: "name",
      headerName: "Token",
      flex: 0.5,
      sortable: false,
      headerAlign: "left",
      align: "left",
      renderCell: (params) => (
        <Stack
          direction="row"
          alignItems={"center"}
          justifyContent="center"
          height="48px"
        >
          <img
            src={params.row.image}
            onError={(e) => (e.currentTarget.src = nftTempImage)}
            alt="nft"
            style={{ width: "31px", height: "31px", borderRadius: "31px" }}
          />
          <Stack direction="column" ml={"10px"}>
            <Typography
              variant="caption"
              color={colors.black[100]}
              fontWeight={600}
            >
              {params.row.tokenName}
            </Typography>
          </Stack>
        </Stack>
      ),
    },
    {
      field: "price",
      headerName: "Price",
      flex: 0.5,
      sortable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Typography
          variant="caption"
          color={colors.black[100]}
          fontWeight={600}
        >
          {params.row.tokenPrice.toFixed(2)}
        </Typography>
      ),
    },

    {
      field: "amount",
      headerName: "Amount",
      sortable: false,
      flex: 0.5,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Typography
          variant="caption"
          color={colors.black[100]}
          fontWeight={600}
        >
          {params.row.tokenBalance.toFixed(2)}
        </Typography>
      ),
    },
    {
      field: "value",
      headerName: "Value",
      flex: 0.5,
      sortable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Typography
          variant="caption"
          color={colors.black[100]}
          fontWeight={600}
        >
          {console.log("params in token", params)}
          {params.row.priceInUSD.toFixed(2)}
        </Typography>
      ),
    },
  ];

  const columnsForTokensPage = [
    {
      field: "name",
      headerName: "Token",
      flex: 0.5,
      sortable: false,
      headerAlign: "left",
      align: "left",
      renderCell: (params) => (
        <Stack
          direction="row"
          alignItems={"center"}
          justifyContent="center"
          height="48px"
        >
          <img
            src={params.row.image}
            onError={(e) => (e.currentTarget.src = nftTempImage)}
            alt="nft"
            style={{ width: "31px", height: "31px", borderRadius: "31px" }}
          />
          <Stack direction="column" ml={"10px"}>
            <Typography
              variant="caption"
              color={colors.black[100]}
              fontWeight={600}
            >
              {params.row.tokenName}
            </Typography>
          </Stack>
        </Stack>
      ),
    },
    {
      field: "price",
      headerName: "Price",
      flex: 0.5,
      sortable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Typography
          variant="caption"
          color={colors.black[100]}
          fontWeight={600}
        >
          {params.row.tokenPrice.toFixed(2)}
        </Typography>
      ),
    },
    {
      field: "accountAllocation",
      headerName: "Account Allocation",
      flex: 0.5,
      sortable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Typography
          variant="caption"
          color={colors.black[100]}
          fontWeight={600}
        >
          {params.row.allocation}
        </Typography>
      ),
    },
    {
      field: "amount",
      headerName: "Amount",
      sortable: false,
      flex: 0.5,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Typography
          variant="caption"
          color={colors.black[100]}
          fontWeight={600}
        >
          {params.row.tokenBalance.toFixed(2)}
        </Typography>
      ),
    },
    {
      field: "value",
      headerName: "Value",
      flex: 0.5,
      sortable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Typography
          variant="caption"
          color={colors.black[100]}
          fontWeight={600}
        >
          {console.log("params in token", params)}
          {params.row.priceInUSD.toFixed(2)}
        </Typography>
      ),
    },
  ];

  return (
    <>
      {collectibles.length > 0 ? (
        <Box
          width="99%"
          // height="240px"
          sx={{
            height: "390px",
            overflow: "scroll",
            "& .MuiDataGrid-root": {
              border: "none",
              outline: "none !important",
              backgroundColor: colors.whiteAccent[900],
            },
            "& .MuiDataGrid-row": {
              // backgroundColor: "#44ACFF",
              borderRadius: "10px",
              color: "#ffffff !important",
              marginBottom: "15px",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
              outline: "none !important",
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: colors.whiteAccent[900],
              borderBottom: "none",
              outline: "none !important",
              fontSize: "16px",
              fontWeight: 400,
            },
            "& .MuiDataGrid-columnHeader": {
              outline: "none !important",
            },
            "& .MuiDataGrid-columnSeparator": {
              visibility: "hidden",
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: colors.whiteAccent[900],
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: colors.whiteAccent[900],
            },
            "& .MuiCheckbox-root": {
              color: `${colors.greenAccent[200]} !important`,
            },
            "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
              color: `${colors.grey[100]} !important`,
            },
          }}
        >
          <DataGrid
            rows={collectibles}
            columns={tokensPage ? columnsForTokensPage : columns}
            getRowId={(row) => row.id}
            rowHeight={48}
            density="standard"
            disableColumnSelector={true}
            disableColumnFilter={true}
            disableColumnMenu={true}
            disableSelectionOnClick={true}
            hideFooter={true}
            // autoHeight={true}
            getRowClassName={(params) => `bg-${params.row.color}`}
          />
        </Box>
      ) : (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "20px",
          }}
        >
          <NoData text="No Collectibles to show!" />
        </Box>
      )}
    </>
  );
};
